<div class="labels-edit-diff-box">
  <header>
    <label>{{headerText}}</label>
  </header>
  <!-- show labels separated and acto -->
  <div *ngIf="edit" class="labels-edit-container">
    <core-labels-text [labels]="matchLabels"></core-labels-text>
    <span class="plus" [hidden]="matchLabels.length == 0 || diffLabels.length == 0 || labels.length< (minLabels + 1)" > + </span>
    <core-label-action
      [hidden]="diffLabels.length == 0 || labels.length< (minLabels + 1)"
      *ngFor="let label of diffLabels"
      [label]="label"
      (actionClick)="removeLabel($event)"
    ></core-label-action>

    <core-labels-text [hidden]="labels.length > minLabels" [labels]="labels"></core-labels-text>

  </div>
  <!-- show labels separated -->
  <div *ngIf="!edit" class="labels-edit-container">
    <core-labels-text [labels]="matchLabels"></core-labels-text>
    <span class="plus" [hidden]="diffLabels.length == 0"> + </span>
    <core-labels-text [labels]="diffLabels"></core-labels-text>
</div>
  <!-- search box -->
  <app-helpers-labels-search-box
    *ngIf="edit"
    [placeholder]="searchPlaceholder"
    [allowClose]="allowClose"
    [exclude]="labelsToExclude"
    [add]="access.access_label_add"
    (choose)="addLabel($event)"
    (close)="close.emit($event)"
    [(input)]="input"
  ></app-helpers-labels-search-box>
</div>
